<template>
  <div class="container-fluid">
    <titular />
    <div class="row mb-5">
      <div class="col-12 col-sm-6 col-md-3 mx-auto">
        <div class="input-group mb-2 mr-sm-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-user" title="Tècnic" v-tooltip></i></div>
          </div>
          <select class="custom-select" v-model="trabajadorEscogido">
            <option value="" hidden>Tècnic</option>
            <option v-for="(trabajador, index) in trabajadores" :key="index" :value="trabajador.id">{{ trabajador.nombre_completo }}</option>
          </select>
        </div>
      </div>
    </div>
    <tabla-pla-dedicacio v-if="trabajadorEscogidoFiltrado" :editable="esPropio || esGranted" :trabajadorEscogido="trabajadorEscogidoFiltrado" />
    <vacio v-else>Utilitza el desplegable superior per escollir tècnic.</vacio>
  </div>
</template>

<script>
import TablaPlaDedicacio from "../components/TablaPlaDedicacio.vue";

export default {
  name: "PlaDedicacio",
  components: {
    TablaPlaDedicacio,
  },
  data() {
    return {
      trabajadores: [],
      trabajadorEscogido: "",
      usuarioRol: null,
      hayDatosSesion: null,
    };
  },
  computed: {
    esGranted() {
      return ["super"].includes(this.usuarioRol);
    },
    esPropio() {
      return this.trabajadorEscogido == localStorage.getItem("usuarioTrabajador");
    },
    trabajadorEscogidoFiltrado() {
      return typeof parseInt(this.trabajadorEscogido) === "number" && this.trabajadores.some(trabajador => trabajador.id == this.trabajadorEscogido) ? parseInt(this.trabajadorEscogido) : null;
    },
  },
  created() {
    this.hayDatosSesion = localStorage.getItem("usuarioRol") !== null && localStorage.getItem("usuarioTrabajador") !== null;

    if (!this.hayDatosSesion) {
      this.$auth = false;

      return;
    }

    this.usuarioRol = localStorage.getItem("usuarioRol");
    this.$http.get("api/treballadors?planificadors&order=nom").then((response) => (this.trabajadores = response.data));
  },
  watch: {
    trabajadores(value) {
      if (value && value.some(trabajador => trabajador.id == localStorage.getItem("usuarioTrabajador"))) {
        this.trabajadorEscogido = localStorage.getItem("usuarioTrabajador");
      }
    }
  },
};
</script>